import _ from 'lodash';
import * as types from '../constants/action-types';

const initialState = {
  experiences: [],
  error: ''
};

export default function nux (state = initialState, action) {
  // customizer resets objects/ array from non-empty to empty
  const mergeCustomizer = (objectValue, sourceValue) => {
    if (!_.isNull(sourceValue) || !_.isUndefined(sourceValue)) {
      return sourceValue;
    }
    return objectValue;
  };
  const { experiences, error } = action;

  switch (action.type) {
  case types.FETCH_NUX_SUCCESS:
    return _.merge({}, state, {
      error,
      experiences
    });

  case types.FETCH_NUX_FAILURE:
    return _.merge({}, state, {
      error
    });

  case types.UPDATE_NUX_SUCCESS:
    return _.mergeWith({}, state, {
      experiences
    }, mergeCustomizer);

  default:
    return state;
  }
}
